import React, { useRef, useEffect } from 'react';

export default function HorizontalCalendar({ selectedDate, onChange }) {
  const scrollRef = useRef(null);

  // สร้างวันที่สำหรับปฏิทิน (ย้อนหลัง 2 วัน ถึง ล่วงหน้า 14 วัน)
  const days = [];
  const today = new Date();
  
  for (let i = -2; i <= 14; i++) {
    const d = new Date();
    d.setDate(today.getDate() + i);
    days.push(d);
  }

  const formatDayName = (date) => {
    const d = date.toLocaleDateString('th-TH', { weekday: 'short' });
    return d;
  };

  const formatDateStr = (date) => {
    // YYYY-MM-DD for backend
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  };

  const isToday = (date) => {
    return date.getDate() === today.getDate() && date.getMonth() === today.getMonth();
  };

  // เลื่อนปฏิทินให้แสดง "วันนี้" อยู่ตรงกลางเมื่อโหลดครั้งแรก
  useEffect(() => {
    if (scrollRef.current) {
      const todayIndex = 2; // ย้อนหลัง 2 วัน วันนี้คือ index 2
      const itemWidth = 60; // กว้างประมาณ 60px
      scrollRef.current.scrollLeft = (todayIndex * itemWidth) - (scrollRef.current.offsetWidth / 2) + (itemWidth / 2);
    }
  }, []);

  return (
    <div className="w-full">
      <div 
        ref={scrollRef}
        className="flex overflow-x-auto gap-2 pb-2 custom-scrollbar snap-x"
        style={{ scrollBehavior: 'smooth' }}
      >
        {days.map((d, index) => {
          const dateStr = formatDateStr(d);
          const isSelected = selectedDate === dateStr;
          const isPast = d < new Date(today.setHours(0,0,0,0));

          return (
            <div 
              key={index}
              onClick={() => onChange(dateStr)}
              className={`snap-center shrink-0 w-[60px] h-[75px] rounded-2xl flex flex-col items-center justify-center cursor-pointer transition-all border ${
                isSelected 
                  ? 'bg-blue-600 border-blue-600 shadow-md shadow-blue-500/30 text-white transform scale-105' 
                  : isPast 
                    ? 'bg-gray-100 border-gray-200 text-gray-400 dark:bg-[#1e293b] dark:border-[#334155] dark:text-gray-500 opacity-60'
                    : 'bg-white border-gray-200 text-gray-700 hover:border-blue-300 hover:bg-blue-50 dark:bg-[#0f172a] dark:border-[#334155] dark:text-gray-300 dark:hover:border-blue-500'
              }`}
            >
              <span className={`text-[10px] font-medium uppercase ${isSelected ? 'text-blue-100' : 'text-gray-500 dark:text-gray-400'}`}>
                {isToday(d) ? 'วันนี้' : formatDayName(d)}
              </span>
              <span className={`text-xl font-black mt-0.5 ${isSelected ? 'text-white' : ''}`}>
                {d.getDate()}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
